import { useReducer, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { createInitialState, reportRequestReducer } from '../model/reducer';
import { stateFromTemplate, TemplateReport } from '../model/templates';
import { FormMode } from '../model/types';

interface LocationState {
  templateReport?: TemplateReport;
}

/**
 * Form state, seeded from the report passed in router state by the Clone /
 * Update menu items. The template is read once, on mount.
 */
const useReportRequestState = (mode: FormMode) => {
  const location = useLocation<LocationState | undefined>();
  const [{ prefill, templateName, templateParams }] = useState(() => {
    const template = location.state?.templateReport;
    return {
      prefill: template ? stateFromTemplate(template, mode) : null,
      templateName: template?.projectName ?? undefined,
      templateParams: template?.params ?? null,
    };
  });
  const [state, dispatch] = useReducer(
    reportRequestReducer,
    undefined,
    () => prefill?.state ?? createInitialState(mode),
  );
  return { state, dispatch, prefill, templateName, templateParams };
};

export default useReportRequestState;
